import { useEffect } from 'react';
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './routes/index';
import { ToolPage } from './routes/tools/[slug]';
import { RefundRocketRoute } from './routes/tools/refundrocket';
import { useUiStore } from './store';
import type { Locale } from './i18n';
import { trackEvent, trackPageview } from './lib/analytics';

function Shell() {
  const locale = useUiStore((s) => s.locale);
  const toggleLocale = useUiStore((s) => s.toggleLocale);
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  // SPA pageview tracking
  useEffect(() => {
    trackPageview();
    trackEvent('page_view', { path: location.pathname });
  }, [location.pathname]);

  const handleToggle = () => {
    const next = locale === 'en' ? 'zh' : 'en';
    toggleLocale();
    trackEvent('language_toggle', { from: locale, to: next });
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Header locale={locale as Locale} onToggleLocale={handleToggle} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tools/refundrocket" element={<RefundRocketRoute />} />
          <Route path="/tools/:slug" element={<ToolPage />} />
          <Route
            path="*"
            element={
              <main className="px-6 py-24 text-center text-slate-500">
                Page not found.
              </main>
            }
          />
        </Routes>
      </div>
      <Footer locale={locale as Locale} />
    </div>
  );
}

export function App() {
  return (
    <HashRouter>
      <Shell />
    </HashRouter>
  );
}

export default App;